import { TableRow } from '@material-ui/core'
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable
} from '@tanstack/react-table'
import React from 'react'
import { useHistory } from 'react-router-dom'
import DebouncedInput from 'src/components/DebounceInput'
import { ILearningModuleSummary } from 'src/models/learning'
import {
  FocusedTableCell,
  HoverableTableRow,
  StyledTable,
  TableHeaderCell
} from 'src/shared/styled/Table'
import { fuzzyFilter } from 'src/utils/table'

interface ILearningModules {
  learningModules: ILearningModuleSummary[]
}

const LearningModules = ({ learningModules }: ILearningModules) => {
  const history = useHistory()

  const columns = React.useMemo<ColumnDef<ILearningModuleSummary, any>[]>(
    () => [
      {
        header: 'Title',
        accessorKey: 'title'
      },
      {
        header: 'Description',
        accessorKey: 'description'
      },
      {
        header: 'Time to Complete',
        accessorKey: 'estimatedDuration',
        enableColumnFilter: false
      },
      {
        header: 'Status',
        accessorKey: 'status',
        enableColumnFilter: false
      }
    ],
    []
  )

  const table = useReactTable({
    columns,
    data: learningModules,
    filterFns: {
      fuzzy: fuzzyFilter
    },
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel()
  })

  return (
    <StyledTable>
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <TableRow key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <TableHeaderCell
                key={header.id}
                style={{ width: header.getSize() }}
              >
                <div>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </div>
                {header.column.getCanFilter() ? (
                  <DebouncedInput
                    type="text"
                    value={(header.column.getFilterValue() ?? '') as string}
                    onChange={(value) => header.column.setFilterValue(value)}
                    placeholder="Search..."
                    list={header.column.id + 'list'}
                  />
                ) : null}
              </TableHeaderCell>
            ))}
          </TableRow>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <HoverableTableRow
            key={row.id}
            onClick={() =>
              history.push(`/learning/${row.original.learningModuleId}`)
            }
          >
            {row.getVisibleCells().map((cell) => (
              <FocusedTableCell key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </FocusedTableCell>
            ))}
          </HoverableTableRow>
        ))}
      </tbody>
    </StyledTable>
  )
}

export default LearningModules
